import React, { useState } from 'react';
import summerCampKids from '../assets/images/summer-camp-kids.jpg';

const SummerCamp = () => {
  const weeks = [
    { id: 'week1', label: 'Week 1: July 14-18', subtitle: 'Rhythm & Numbers', price: 300 },
    { id: 'week2', label: 'Week 2: July 21-25', subtitle: 'Dancing with Digits', price: 300 },
    { id: 'week3', label: 'Week 3: August 5-8', subtitle: 'Rhythm & Numbers (BC Day**)', price: 240 },
    { id: 'week4', label: 'Week 4: August 11-15', subtitle: 'Dancing with Digits', price: 300 }
  ];

  const handleApplyNow = () => {
    // This would redirect to Square checkout with the camp options
    // For now, we'll show an alert with the instructions
    // gtag_report_conversion('https://math-x-movement-summer-camp.square.site/');
    const applyNowPage = 'https://math-x-movement-summer-camp.square.site/';
    window.gtag_report_conversion(applyNowPage,300);
    window.open(applyNowPage, '_blank');
  };

  const handleNDDesignation = () => {
    // This would open payment + Google Form for ND designation
    const ndDesignationPage = 'https://math-x-movement-summer-camp-nd.square.site/';
    window.gtag_report_conversion(ndDesignationPage,300);
    window.open(ndDesignationPage, '_blank');    
  };

  const handleScholarship = () => {
    // This would open the Google Form for scholarship applications
    const scholarshipForm = 'https://docs.google.com/forms/d/e/1FAIpQLSdScAqGrBCNlS4La9sHtb6ig9HysV4OrQ8Nnk3OhOvuEexjcQ/viewform';
    window.gtag_report_conversion(scholarshipForm,0);
    window.open(scholarshipForm, '_blank');    
  };

  const handleDonate = () => {
    // This would open donation page
    const donationPage = 'https://checkout.square.site/merchant/MLBQYHXVHCTX2/checkout/ZJ4ULMWYLIYMUSXW2VQ6OFUT';
    window.gtag_report_conversion(donationPage,100);
    window.open(donationPage, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-400 via-pink-500 to-red-500">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center text-white mb-12 pt-12">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 drop-shadow-lg">
            🎵 MATH X MOVEMENT 🎭
          </h1>
          <p className="text-xl md:text-2xl opacity-90">
            Get ready to have fun with math, Latin music, and dance this summer!
          </p>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden max-w-6xl mx-auto">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white p-12 text-center relative overflow-hidden">
            <div className="absolute inset-0 bg-black bg-opacity-10"></div>
            <div className="relative z-10">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">Math X Movement Summer Camp</h2>
              <p className="text-xl mb-6">Discover the Math and Movement Summer Camp</p>
              <div className="inline-block bg-white bg-opacity-20 px-6 py-3 rounded-full text-lg font-semibold">
                Ages 6-7 Years (Born in 2018 or 2019)
              </div>
            </div>
          </div>

          {/* Kids Photo Section */}
          <div className="relative h-[500px] md:h-[600px] overflow-hidden">
            <img 
              src={summerCampKids}
              alt="Happy children at summer camp waving and smiling"
              className="w-full h-full object-cover"
            />
          </div>

          {/* About Section */}
          <div className="p-8 bg-gray-50">
            <div className="prose max-w-none text-gray-700">
              <p className="text-lg mb-6">
                Welcome! Rueda de la Vida is an organization passionate about building vibrant and resilient communities through the joy and art of dance. Our mission is to make dance an accessible, uplifting, and empowering experience that allows everyone to feel the transformative effects of movement and connection.
              </p>
              <p className="mb-6">
                This innovative camp combines the joy of dance with the fundamentals of math, offering a unique learning experience.
              </p>
              <p className="mb-6">
                The camp spans four week-long sessions in July and August, focusing on AfroLatin dance and music, aligning with Rueda de la Vida's mission.
              </p>
            </div>
          </div>

          {/* Activities Section */}
          <div className="p-8 bg-white">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Our Activities Include:</h3>
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="text-center bg-gray-50 p-6 rounded-lg shadow-md">
                <div className="text-4xl mb-4">🏃‍♂️</div>
                <h4 className="font-bold mb-3 text-blue-600">Sports Days</h4>
                <p className="text-sm text-gray-600">Encouraging children to count items while participating in races, combining physical activity with counting skills.</p>
              </div>
              <div className="text-center bg-gray-50 p-6 rounded-lg shadow-md">
                <div className="text-4xl mb-4">🎵</div>
                <h4 className="font-bold mb-3 text-blue-600">Music Lessons</h4>
                <p className="text-sm text-gray-600">Conducted by instructors such as Frankie Hidalgo, guiding campers in counting beats (2, 4, 8 counts) across various Latin music styles while moving to the rhythm.</p>
              </div>
              <div className="text-center bg-gray-50 p-6 rounded-lg shadow-md">
                <div className="text-4xl mb-4">💃</div>
                <h4 className="font-bold mb-3 text-blue-600">Dance Activities</h4>
                <p className="text-sm text-gray-600">Fostering creativity by having kids design dance steps inspired by different shapes, turning learning into a fun and engaging experience.</p>
              </div>
            </div>
            <p className="text-gray-700 mb-4">
              In a globalized world where traditional and cultural expressions can be overlooked, our camp aims to enrich children's learning and cultural appreciation through Latin music and dance. Join us in this vibrant celebration of movement and learning!
            </p>
            <p className="text-lg font-semibold text-blue-600 mb-6">
              🌟 We encourage neurodiverse children to apply!
            </p>
          </div>

          {/* Schedule and Details */}
          <div className="grid md:grid-cols-2 gap-0">
            <div className="p-8 bg-gray-50">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Camp Schedule</h3>
              <div className="space-y-4 mb-8">
                {weeks.map((week) => (
                  <div key={week.id} className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-400">
                    <h4 className="text-blue-600 font-semibold mb-1">{week.label}</h4>
                    <p className="text-gray-600">{week.subtitle}</p>
                    <p className="text-sm text-gray-500 mt-1">${week.price} {week.id === 'week3' && '(4-day week)'}</p>
                  </div>
                ))}
              </div>
              <div className="bg-white p-4 rounded-lg shadow-md mb-6">
                <p className="text-sm text-gray-600 mb-2">
                  <strong>*Both Rhythm & Numbers and Dancing with Digits</strong> capture the essence of combining music, dance, and mathematical learning, inviting children to explore the interplay between rhythm and numbers. The difference is in the content of activities! We invite parents to register for both if interested.
                </p>
                <p className="text-sm text-orange-600 font-semibold">
                  **Week 3 is a 4-day week due to BC Day and has reduced rates of $240.
                </p>
              </div>
            </div>

            <div className="p-8 bg-white">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Camp Details</h3>
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-4">
                  <div className="text-2xl">⏰</div>
                  <div>
                    <h4 className="font-bold">Time</h4>
                    <p className="text-gray-600">9:00 AM - 3:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-2xl">$</div>
                  <div>
                    <h4 className="font-bold">Price</h4>
                    <p className="text-gray-600">$300 per week</p>
                    <p className="text-sm text-orange-600">Week 3: $240 (4-day week)</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-2xl">👶</div>
                  <div>
                    <h4 className="font-bold">Age Group</h4>
                    <p className="text-gray-600">Children aged 6-7 years</p>
                    <p className="text-sm text-blue-600">(Born in 2018 or 2019)</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-2xl">📍</div>
                  <div>
                    <h4 className="font-bold">Location</h4>
                    <p className="text-gray-600">Hudson Elementary School<br />Classroom #210<br />1551 Cypress St, Vancouver, BC V6J 3L3</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-2xl">⚠️</div>
                  <div>
                    <h4 className="font-bold text-red-600">Limited Spots</h4>
                    <p className="text-gray-600">Only 15 spots per week</p>
                    <p className="text-sm text-blue-600">**2 spots each week reserved for kids with neurodiversity designation</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-2xl">👥</div>  
                  <div>
                    <h4 className="font-bold text-purple-600">1:1 Support</h4>
                    <p className="text-sm text-green-600">✅ Available for children with ND designation</p>
                    <p className="text-sm text-red-600">❌ Not available for children without ND designation</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Application Deadlines - Moved under Scholarships */}
          
          {/* Scholarships and Cancellation */}
          <div className="p-8 bg-blue-50">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">🎓 Scholarships Available</h3>
                <p className="text-gray-700 mb-4">
                  3 applicants each week, from low-income families will be eligible for partial or full scholarships. This is a trust-based application process - please allow families who might benefit from this opportunity more to apply!
                </p>
                <div className="bg-yellow-100 p-4 rounded-lg mt-4">
                  <h4 className="font-bold text-gray-800 mb-2">📅 Scholarship Application Deadlines</h4>
                  <div className="space-y-2 text-sm">
                    <div>
                      <p className="font-semibold">For Week 1</p>
                      <p>Apply by <strong>June 30</strong> - You will hear back by July 3rd</p>
                    </div>
                    <div>
                      <p className="font-semibold">For Week 2</p>
                      <p>Apply by <strong>July 9</strong> - You will hear back by July 13th</p>
                    </div>                    
                    <div>
                      <p className="font-semibold">For Weeks 3 & 4:</p>
                      <p>Apply by <strong>July 16</strong> - You will hear back by July 20th</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-4">📋 Cancellation Policy</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                  <li>• Cancel 2 weeks before: <strong>100% refund</strong></li>
                  <li>• Cancel less than 2 weeks but more than 48 hours before: <strong>75% refund</strong></li>
                  <li>• Cancel less than 48 hours but more than 24 hours before: <strong>50% refund</strong></li>
                  <li>• Cancel less than 24 hours before: <strong>No refund</strong></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Registration Buttons */}
          <div className="p-8 bg-white text-center">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Choose Your Registration Option</h3>
            <div className="space-y-4 max-w-2xl mx-auto">
              <button
                onClick={handleApplyNow}
                className="w-full bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold py-4 px-6 rounded-lg text-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
              >
                🚀 REGISTER (WITHOUT ND DESIGNATION)
                <div className="text-sm opacity-90 mt-1">My child does not have a ND designation or require a scholarship</div>
                <div className="text-xs opacity-80 mt-1">❌ No 1:1 support available</div>
              </button>
              
              <button
                onClick={handleNDDesignation}
                className="w-full bg-gradient-to-r from-purple-500 to-pink-500 text-white font-bold py-4 px-6 rounded-lg text-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
              >
                🌟 REGISTER (WITH ND DESIGNATION)
                <div className="text-sm opacity-90 mt-1">My child has a ND designation but does not require a scholarship</div>
                <div className="text-xs opacity-80 mt-1">✅ Includes 1:1 support</div>
              </button>
              
              <button
                onClick={handleScholarship}
                className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white font-bold py-4 px-6 rounded-lg text-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
              >
                🎓 SCHOLARSHIP APPLICATION
                <div className="text-sm opacity-90 mt-1">My child requires a scholarship (and if applicable, has a ND designation)</div>
                <div className="text-xs opacity-80 mt-1">✅ Includes 1:1 support if ND designation</div>
              </button>

              <button
                onClick={handleDonate}
                className="w-full bg-gradient-to-r from-yellow-500 to-orange-400 text-white font-bold py-4 px-6 rounded-lg text-lg hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 border-2 border-yellow-300"
              >
                💝 DONATE NOW
                <div className="text-sm opacity-90 mt-1">Sponsor another child for summer camp!</div>
              </button>
            </div>
            <p className="text-sm text-gray-600 mt-6">
              Questions? Contact us at <a href="mailto:summercamp@ruedadance.org" className="text-blue-600 hover:underline">summercamp@ruedadance.org</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummerCamp;